import { View } from './view'

export const Profit = View
